// extracted by mini-css-extract-plugin
module.exports = {"container":"_2vAnMe0iqhZ0-neBfG_3lG","label":"O86Gg_eZUdWCmYjNJF36U","description":"_3SL9xgUrPwPMc7DFP8lR5l description","icon":"_3NyiczQljxQ7seT6iPyhSS"};